export default __webpack_public_path__ + "static/media/Habo_full.ecded306.svg";